import React from 'react';

const DomainBlockedMessage = ({ parentUrl }) => {
  const getCurrentDomain = () => {
    try {
      const url = parentUrl || window.location.href;
      // Decode the URL if it's encoded
      const decodedUrl = decodeURIComponent(url);
      return new URL(decodedUrl).hostname;
    } catch {
      return 'Unknown';
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-full px-4 text-center">
      <div className="max-w-sm mx-auto">
        <div className="mb-4">
          <div className="w-12 h-12 mx-auto mb-3 bg-red-100 rounded-full flex items-center justify-center">
            <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
        </div>
        <h3 className="text-lg font-semibold text-[var(--dt-color-element-100)] mb-2">
          Access Restricted
        </h3>
        <p className="text-sm text-[var(--dt-color-element-80)] mb-3 leading-relaxed">
          This chatbot is not authorized to run on this website. The chatbot owner has restricted access to specific domains only.
        </p>
        <p className="text-xs text-[var(--dt-color-element-60)] mb-3">
          If you believe this is an error, please contact the chatbot owner to add this website's URL to their whitelisted domains.
        </p>
        <div className="text-xs text-[var(--dt-color-element-50)] bg-[var(--dt-color-element-5)] rounded-md p-2">
          <strong>Current domain:</strong> {getCurrentDomain()}
        </div>
      </div>
    </div>
  );
};

export default DomainBlockedMessage;
